module.exports = __webpack_public_path__ + "img/img12.04eaf20e.svg";